/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { ExceptionResponseDTO } from '../model/models';
import { GetProfiloServizio409Response } from '../model/models';
import { GetProfiloServizio422Response } from '../model/models';
import { Pageable } from '../model/models';
import { PagedModelTipoPraticaIstitutoPlessoAssegnazioneDTO } from '../model/models';
import { TipoPraticaIstitutoPlessoAssegnazioneCreationForm } from '../model/models';
import { TipoPraticaIstitutoPlessoAssegnazioneDTO } from '../model/models';
import { TipoPraticaIstitutoPlessoAssegnazioneListFilter } from '../model/models';
import { TipoPraticaIstitutoPlessoAssegnazionePatchForm } from '../model/models';


import { Configuration }                                     from '../configuration';


export interface CreateTipoPraticaIstitutoPlessoAssegnazioneRequestParams {
    idTipoPratica: string;
    idIstituto: string;
    idPlesso: string;
    tipoPraticaIstitutoPlessoAssegnazioneCreationForm: TipoPraticaIstitutoPlessoAssegnazioneCreationForm;
}

export interface DeleteTipoPraticaIstitutoPlessoAssegnazioneRequestParams {
    idTipoPratica: string;
    idIstituto: string;
    idPlesso: string;
    idAssegnazione: string;
}

export interface GetTipoPraticaIstitutoPlessoAssegnazioneRequestParams {
    idTipoPratica: string;
    idIstituto: string;
    idPlesso: string;
    idAssegnazione: string;
}

export interface ListTipoPraticaIstitutoPlessoAssegnazioniRequestParams {
    idTipoPratica: string;
    idIstituto: string;
    idPlesso: string;
    filter: TipoPraticaIstitutoPlessoAssegnazioneListFilter;
    pageable: Pageable;
}

export interface UpdateTipoPraticaIstitutoPlessoAssegnazioneRequestParams {
    idTipoPratica: string;
    idIstituto: string;
    idPlesso: string;
    idAssegnazione: string;
    tipoPraticaIstitutoPlessoAssegnazionePatchForm: TipoPraticaIstitutoPlessoAssegnazionePatchForm;
}


export interface TipoPraticaIstitutoPlessoAssegnazioneControllerServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Crea una nuova Assegnazione (classe, sezione) sotto un Plesso
     * 
     * @endpoint post /api/v1/gestione/tipi-pratica/{idTipoPratica}/istituti/{idIstituto}/plessi/{idPlesso}/assegnazioni
* @param requestParameters
     */
    createTipoPraticaIstitutoPlessoAssegnazione(requestParameters: CreateTipoPraticaIstitutoPlessoAssegnazioneRequestParams, extraHttpRequestParams?: any): Observable<TipoPraticaIstitutoPlessoAssegnazioneDTO>;

    /**
     * Elimina un\&#39;Assegnazione
     * 
     * @endpoint delete /api/v1/gestione/tipi-pratica/{idTipoPratica}/istituti/{idIstituto}/plessi/{idPlesso}/assegnazioni/{idAssegnazione}
* @param requestParameters
     */
    deleteTipoPraticaIstitutoPlessoAssegnazione(requestParameters: DeleteTipoPraticaIstitutoPlessoAssegnazioneRequestParams, extraHttpRequestParams?: any): Observable<{}>;

    /**
     * Dettaglio di un\&#39;Assegnazione per id
     * 
     * @endpoint get /api/v1/gestione/tipi-pratica/{idTipoPratica}/istituti/{idIstituto}/plessi/{idPlesso}/assegnazioni/{idAssegnazione}
* @param requestParameters
     */
    getTipoPraticaIstitutoPlessoAssegnazione(requestParameters: GetTipoPraticaIstitutoPlessoAssegnazioneRequestParams, extraHttpRequestParams?: any): Observable<TipoPraticaIstitutoPlessoAssegnazioneDTO>;

    /**
     * Lista paginata delle Assegnazioni di un Plesso (filtri: classe, sezione, attivo, con_contributo)
     * 
     * @endpoint get /api/v1/gestione/tipi-pratica/{idTipoPratica}/istituti/{idIstituto}/plessi/{idPlesso}/assegnazioni
* @param requestParameters
     */
    listTipoPraticaIstitutoPlessoAssegnazioni(requestParameters: ListTipoPraticaIstitutoPlessoAssegnazioniRequestParams, extraHttpRequestParams?: any): Observable<PagedModelTipoPraticaIstitutoPlessoAssegnazioneDTO>;

    /**
     * Replace di un\&#39;Assegnazione (richiede version per optimistic lock)
     * 
     * @endpoint put /api/v1/gestione/tipi-pratica/{idTipoPratica}/istituti/{idIstituto}/plessi/{idPlesso}/assegnazioni/{idAssegnazione}
* @param requestParameters
     */
    updateTipoPraticaIstitutoPlessoAssegnazione(requestParameters: UpdateTipoPraticaIstitutoPlessoAssegnazioneRequestParams, extraHttpRequestParams?: any): Observable<TipoPraticaIstitutoPlessoAssegnazioneDTO>;

}
